import Api from '@/services/Index';

const getAll = async (config) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get('/program/outcomes', config);
}

const show = async (id) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get('/program/outcomes/'+id);
}

const store = async (data) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.post('/program/outcomes', data);
}

const update = async (id,data) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.put('/program/outcomes/'+id, data);
}

const del = async (id) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.delete('/program/outcomes/'+id);
}

const storeOutcomeSemesters = async (data) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT
    return Api.post('/program/outcome/semesters', data)
}

const getAllOutcomeSemesters = async (config) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get('/program/outcome/semesters', config);
}

const updateOutcomeSemesters = async (id,data) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.put('/program/outcome/semesters/'+id, data);
}

const delOutcomeSemesters = async (id) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.delete('/program/outcome/semesters/'+id);
}

const bulkImport = async (formData) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT
    return Api.post('/program/outcomes/import', formData)
}

export default {
    getAll,
    store,
    show,
    update,
    del,
    storeOutcomeSemesters,
    getAllOutcomeSemesters,
    updateOutcomeSemesters,
    delOutcomeSemesters,
    bulkImport
}
